import { SidebarMenu } from './Sidebar'

export const NavigationLinks = {
    [SidebarMenu.Tenants]: '/manage-tenants',
    [SidebarMenu.EtpSync]: '/data-sync',
    [SidebarMenu.APIInsights]: '/api-insights',
    [SidebarMenu.IntegrationInsights]: '/integration-insights',
    [SidebarMenu.ServiceStatus]: '/service-status',
    [SidebarMenu.ErrorStatus]: '/error-insights',
    [SidebarMenu.DataPreview]: '/data-preview',
    [SidebarMenu.InvoiceDashboard]: '/invoice-dashboard',
    [SidebarMenu.MarkPackagesPaid]: '/mark-packages-paid',
    [SidebarMenu.SupersetPresets]: '/superset-presets',
    [SidebarMenu.HelpVideos]: '/help-videos',
    [SidebarMenu.EmailValidation]: '/email-validation',
    // [SidebarMenu.TenantAnalytics]: '/tenant-onboard-analytics',
}
